/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:fms` or
 *    `npm run generate:graphql:fms:local` in the terminal
 */

import * as Types from '../../../../../types/FMSGraphqlTypes'

import { gql } from '@apollo/client'
export type ITrailerFragment = { __typename?: 'Trailer' } & Pick<
  Types.ITrailer,
  'id' | 'number' | 'note' | 'state' | 'arrivedAt'
> & {
    shipmentDetails?: Types.Maybe<
      { __typename?: 'TrailerShipmentDetails' } & Pick<
        Types.ITrailerShipmentDetails,
        | 'id'
        | 'state'
        | 'pickupArrivedAt'
        | 'pickupTrailerArrivedAt'
        | 'pickupTrailerEmptiedAt'
        | 'pickupTimezone'
        | 'deliveryArrivedAt'
        | 'deliveryTrailerEmptiedAt'
        | 'deliveryTrailerArrivedAt'
        | 'deliveryTimezone'
      >
    >
    facility?: Types.Maybe<
      { __typename?: 'TrailerShipperFacility' } & Pick<Types.ITrailerShipperFacility, 'id' | 'name'>
    >
  }

export const TrailerFragmentDoc = gql`
  fragment Trailer on Trailer {
    id
    number
    note
    state
    arrivedAt
    shipmentDetails {
      id
      state
      pickupArrivedAt
      pickupTrailerArrivedAt
      pickupTrailerEmptiedAt
      pickupTimezone
      deliveryArrivedAt
      deliveryTrailerEmptiedAt
      deliveryTrailerArrivedAt
      deliveryTimezone
    }
    facility {
      id
      name
    }
  }
`
